import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import routerConstant from "service/constant/routerConstant";
import { AskGraveMoveType } from "service/constant/serviceConstant";
import type { IAskGraveMoveList } from "service/interface/apply";

interface Props {
  data: IAskGraveMoveList[];
  selectTable: number[];
  setSelectTable: React.Dispatch<React.SetStateAction<number[]>>;
}

export function AskGraveMoveListTable({
  data,
  selectTable,
  setSelectTable,
}: Props) {
  const navigate = useNavigate();
  const handleAllCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectTable(data.map((list) => list.id));
    } else {
      setSelectTable([]);
    }
  };

  const handleTableCheckBox = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => {
    if (e.target.checked) {
      setSelectTable((prev) => [...prev, id]);
    } else {
      let copiedArr = selectTable.filter((table) => table !== id);
      setSelectTable(copiedArr);
    }
  };

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.ASKGRAVEMOVE.index}/${id}`);
  };

  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              <input
                type="checkbox"
                className="h-4 w-4 cursor-pointer rounded border-gray-4 text-blue-3 focus:ring-0 focus:ring-[#f5f8ff]"
                checked={
                  data.length !== 0 && selectTable.length === data.length
                }
                onChange={handleAllCheckBox}
              />
            </th>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[100px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              문의 형태
            </th>
            <th
              scope="col"
              className="min-w-[100px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              봉분 기수
            </th>
            <th
              scope="col"
              className="min-w-[100px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              회원 구분
            </th>
            <th
              scope="col"
              className="min-w-[100px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              이름
            </th>
            <th
              scope="col"
              className="min-w-[323px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              휴대폰 번호
            </th>
            <th
              scope="col"
              className="min-w-[100px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              신청 일자
            </th>
            <th
              scope="col"
              className="min-w-[100px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              처리 상태
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((service) => (
            <tr
              key={service.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
              onClick={() => handleTableClick(service.id)}
            >
              <td
                onClick={(e) => e.stopPropagation()}
                className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5"
              >
                <input
                  type="checkbox"
                  className="h-4 w-4 cursor-pointer rounded border-gray-4 text-blue-3 focus:ring-0 focus:ring-[#f5f8ff]"
                  checked={selectTable.includes(service.id)}
                  onChange={(e) => handleTableCheckBox(e, service.id)}
                />
              </td>
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {service.id}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {AskGraveMoveType[service.type]}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {service.burialCount}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {service.UserId ? "회원" : "비회원"}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {service.name}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {service.phoneNumber}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(service.createdAt).format("YYYY-MM-DD")}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {service.status === 0 ? "대기중" : "처리 완료"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
